<script lang="ts">
  import {
    Container,
    Row,
    Col, Card, CardBody,
  } from "sveltestrap"
  import Stake from "../components/Stake.svelte"
  import { query } from "@urql/svelte"
  import { connected, chainId, selectedAccount, web3 } from "svelte-web3"
  import { nFormatter } from "../utils/utils"
  import { STAKING_ABI} from "../abis/staking"
  import { getXPilRatio } from "../stores/query"
  import { CONFIG } from "../config"

  let xPilLocked = 0;
  let xPilUnlocked = 0;
  let xPilRatio = 1;
  let xPilAPY = 0;

  query(getXPilRatio);

  const getXPilBalance = async () => {
    if (!$connected) return 0;
    const stakingContract = new $web3.eth.Contract(STAKING_ABI, CONFIG[$chainId].STAKING_ADDRESS);
    xPilLocked = Number.parseFloat(await stakingContract.methods.getLockedAmount($selectedAccount).call()) / 1e18;
    xPilUnlocked = Number.parseFloat(await stakingContract.methods.getUnlockedAmount($selectedAccount).call()) / 1e18;
  }

  $: if ($connected) {
    getXPilBalance();
  }

  $: try {
    if(!$getXPilRatio.fetching && $getXPilRatio.data !== undefined) {
      const now = Date.now() / 1000;
      let dayOpenRatio;
      let dayOpenTs;
      for (let hourData of $getXPilRatio.data.stakingHourDatas) {
        dayOpenRatio = hourData.openRatio;
        const ts = Number.parseInt(hourData.id);
        dayOpenTs = ts;
        if (now - ts > 86400) {
          break;
        }
      }
      xPilRatio = $getXPilRatio.data.stakingHourDatas[0].closeRatio;
      xPilAPY = ((xPilRatio - dayOpenRatio) / (now - dayOpenTs) * 60 * 60 * 24 * 365) / dayOpenRatio * 100;
    }
  } catch(e) {
    console.error(e);
  }
</script>

<Container>
  <Row>
    <Col class="page-title-staking">
      Staking
    </Col>
  </Row>
  <Row>
    <Col lg="8" class="page-desc">
      <p class="staking-desc-highlight">
        Supercharge your PIL to xPIL!
      </p>
      <p>
        Staking PIL here returns xPIL. xPIL, or staked PIL, receives a portion of trading fees from the entire protocol, plus extra tokens from the Protocol Treasury. xPIL holders also have voting power over the Pilgrim DAO, which controls important protocol parameters like extra PIL rewards.
      </p>
      <p>
        <strong class="staking-desc-highlight negative">Note that staking PIL for xPIL locks your PIL for a year — this is an irreversible transaction!</strong> <br/>While you may sell xPIL back to PIL, keep in mind that market selling xPIL may result in significant discounts.
      </p>
    </Col>
  </Row>
  <Row class="gy-4">
    <Col xs="12" lg="4" class="order-last order-lg-first">
      <Card class="info-card staking-balance">
        <CardBody class="staking-balance-body">
          <Row class="staking-balance-title">
            Your Balance
          </Row>
          <Row class="staking-balance-subtitle">
            Locked
          </Row>
          <Row>
            <Col class="col-auto staking-symbol-col">
              <img class="staking-symbol" src="/icons/pil-fill-shadow.svg" alt="placeholder"/>
            </Col>
            <Col class="staking-balance-col">
              <Row class="staking-balance-value">
                {nFormatter(xPilLocked, 2)}
              </Row>
              <Row class="staking-balance-unit">
                xPIL
              </Row>
            </Col>
          </Row>
          <Row class="staking-balance-subtitle">
            Unlocked
          </Row>
          <Row>
            <Col class="col-auto staking-symbol-col">
              <img class="staking-symbol" src="/icons/pil-line-shadow.svg" alt="placeholder"/>
            </Col>
            <Col class="staking-balance-col">
              <Row class="staking-balance-value">
                {nFormatter(xPilUnlocked, 2)}
              </Row>
              <Row class="staking-balance-unit">
                xPIL
              </Row>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
    <Col xs="12" lg="8" class="order-first order-lg-last">
      <Row >
        <Stake xPilUnlocked={xPilUnlocked} xPilRatio={xPilRatio}/>
      </Row>
      <Row>
        <Col>
          <Card class="staking-apr">
            <Row class="align-items-center" cols={{ xs: 1, sm: 2}}>
              <Col>
                Staking APR
                <img class="icon-small" src="/icons/question.svg" alt="placeholder"/>
              </Col>
              <Col>
                <Row cols={{ xs: 2, sm: 1}}>
                  <Col class="col-auto staking-apr-value">
                    {nFormatter(xPilAPY, 2)} %
                  </Col>
                  <Col class="col-auto staking-apr-desc">
                    Yesterday's APR
                  </Col>
                </Row>
<!--                <Row class="staking-apr-value ">-->
<!--                  {nFormatter(xPilAPY, 2)} %-->
<!--                </Row>-->
<!--                <Row class="staking-apr-desc ">-->
<!--                  Yesterday's APR-->
<!--                </Row>-->
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </Col>
  </Row>
</Container>

